import BaseComponent from '../../../js/base-component';

class FaqList extends BaseComponent {
    constructor(element) {
        super(element);

        // open/close adress entry
        const entries =  this.element.querySelectorAll('.u-faq-item');

        if (entries.length) {
            entries.forEach((ele) => {
                if (!ele.classList.contains('faq-init')) {

                    ele.querySelector('.u-faq-item__headline').addEventListener('click', function (evt) {
                        evt.preventDefault();
                        toggleFAQ(evt);
                    });
                    ele.classList.add('faq-init');
                }
            });
        }

        function toggleFAQ(evt) {
            let rootEle = evt.target.closest('.u-faq-item');

            if (rootEle.classList.contains('is--active')) {
                rootEle.classList.remove('is--active');
            } else {
                rootEle.classList.add('is--active');
            }
        }
    }
}

export default {
    name: 'FaqList',
    definition: FaqList
};
